// src/utils/api.ts
// API base URL from .env (REACT_APP_API_BASE_URL)
export const BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3005';

export async function apiFetch<T = any>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const token = localStorage.getItem("token");
  const headers: Record<string,string> = {
    "Content-Type": "application/json",
    ...(options.headers as any),
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };

  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers
  });

  if (res.status === 401) {
    const errorData = await res.json().catch(() => ({}));
    if (errorData.message === 'Token expired' || errorData.code === 'TOKEN_EXPIRED') {
      console.log('Session expired, redirecting to login...');
    }
    localStorage.clear();
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Error ${res.status}`);
  }
  return (res.status === 204 ? ({} as T) : (await res.json())) as T;
}
